export const isValueIncludes = <T>(value: T, array: T[]) => {
  return array.includes(value);
};
